// extracted by mini-css-extract-plugin
export default {"full_body":"App_full_body__1cQWh","quest_board_title":"App_quest_board_title__K9qGV"};